module.exports = "/_next/static/resources/pack-e9645d0f1e6769f393a88595d16d48c5.webp";